import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from 'styles/breakpoints';

const Header = styled.h1`
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 900;
  font-size: ${props => (props.textLength > 100 ? '20px' : '32px')};
  line-height: ${props => (props.textLength > 100 ? '30px' : '38px')};
  text-transform: uppercase;
  margin: 0;

  ${media.small`
    font-size: ${props => (props.textLength > 100 ? '32px' : '38px')}
    line-height: ${props => (props.textLength > 100 ? '40px' : '48px')}
    width: 80%;
    margin: 0 auto;
  `} ${media.medium`
    font-size: ${props => (props.textLength > 100 ? '36px' : '46px')};
    line-height: ${props => (props.textLength > 100 ? '48px' : '55px')};
    width: 80%;
    margin: 0 auto;
  `};
`;

export default function Headline({ text }) {
  if (!text) return null;

  return <Header textLength={text.length}>{text}</Header>;
}

Headline.propTypes = {
  text: PropTypes.string
};

Headline.defaultProps = {
  text: null
};



// WEBPACK FOOTER //
// ./src/components/Headline/Headline.js